declare const TIME_BRAND: unique symbol;
/** A duration in minutes. Construct only via `time(hr, min)` — the brand prevents raw-number assignment. */
export type Time = number & { readonly [TIME_BRAND]: never };

/** Build a `Time` from hours + minutes. Either field defaults to 0. */
export function time(hr: number = 0, min: number = 0): Time {
  return (hr * 60 + min) as Time;
}

/** Render a `Time` as a human-readable string ("12 hr", "20 min", "1 hr 30 min"). */
export function formatTime(t: Time): string {
  const h = Math.floor(t / 60);
  const m = t % 60;
  if (h > 0 && m > 0) return `${h} hr ${m} min`;
  if (h > 0) return `${h} hr`;
  return `${m} min`;
}

/** Sum two `Time` values, preserving the brand. */
export function addTimes(a: Time, b: Time): Time {
  return (a + b) as Time;
}
